export enum EFairPlayErrorCode {
  /** заявка "Работаем честно" отклонена */
  requestDeclined = 'requestDeclined',
  /** запрос успешен, но тело ответа пустое */
  emptyResponse = 'emptyResponse',
  /** неизвестная ошибка на сервере */
  fatalError = 'fatalError',
}
